import {guidesCountQueryOptions, PaginatedQuery} from '@blesk-frontend/api';
import {Updater, useMutation, useQueryClient} from '@tanstack/react-query';
import {fetchCollectionDelete} from './fetchCollectionDelete';
import {Collection} from './types';

type CollectionUpdaterData = Collection | PaginatedQuery<Collection> | undefined;

/**
 * This mutation hook is used to update the Collection.
 */
export const useCollectionDeleteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fetchCollectionDelete,
    onSuccess(_data, variables) {
      queryClient.refetchQueries({queryKey: guidesCountQueryOptions().queryKey});

      const updater: Updater<CollectionUpdaterData, CollectionUpdaterData> = (old) => {
        if (!old) {
          return old;
        }
        if ('pagination' in old) {
          return {
            ...old,
            data: old.data.filter((collection) => collection.id !== variables),
          };
        }
      };
      queryClient.setQueriesData<CollectionUpdaterData>({queryKey: ['collections']}, updater);
    },
  });
};
